import { render } from "./AddConfigurationForm.vue?vue&type=template&id=9fab5df8"
import script from "./AddConfigurationForm.vue?vue&type=script&lang=js"
export * from "./AddConfigurationForm.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "9fab5df8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9fab5df8', script)) {
    api.reload('9fab5df8', script)
  }
  
  module.hot.accept("./AddConfigurationForm.vue?vue&type=template&id=9fab5df8", () => {
    api.rerender('9fab5df8', render)
  })

}

script.__file = "src/components/dashboard/AddConfigurationForm.vue"

export default script